import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

const GLOBAL = require('../../Globals');

class EmployeeSalary extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			year : (new Date()).getFullYear(),
			month : '',
			depart : '',
			chk : '',
			_message : '',
			alertClass :'',
			accyear : [],
			depat : [],
			sub : [],
			emp : [],
			emptotal : [],
			data : [],
			_redirect : false,
			payhead : [],
			phead : [],
			advancedata : [],
			absent : [],
			leave : '',
			count : '',
			deductdata : [],
		}
		
		this.onSubmit = this.onSubmit.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onChangeAlert = this.onChangeAlert.bind(this);
	}
	
	onSubmit(e){
		
		e.preventDefault();
		
	}
	
	onChangeAlert(){
		
		alert('Allocated...');
	}
	
	handleChange(id,subj,e){
		
		this.state.teacher = id;
		this.state.subject = subj;
		
		if(e.target.checked){
			
			this.state.chk = '1';
		}
		else{
			
			this.state.chk = '0';
		}
		
		if(this.state.acyear && this.state.depart && this.state.teacher && this.state.subject){
			$("#showLoader").show();
			PostData('subjectallocation/add',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.getdata();
					alert('Success!...');
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
					document.getElementById("subform").reset();
				}
			});
		}
	}
	
	onChange(e){
		
		this.getemployee();
		this.setState({[e.target.name]:e.target.value});
		this.state.leave = '';
		this.state.count = '';
		this.getsunday();
		this.getabsent();
		this.getleave();
		
		console.log(this.state);
	}
	
	componentWillMount(){
		
		this.getdepartment();
		this.getacyear();
		this.getpayhead();
		this.getphead();
		this.getsalsetdata();
		this.getsaladvance();
		this.getleavededuct();
		this.getdeductloan();
	}
	
	// Get Leave Deduct
	getleavededuct(){
		
		GetData('payroll/getleave').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Absent **/
	getabsent(){
		$("#showLoader").show();
		var ac = $("#year").val();
		var month = $("#month").val();
		var year = this.state.year;
		
		GetData('payroll/getabsent/'+ac+'/'+year+'/'+month).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					absent : responseJson
				});
			}
		});
	}
	
	/** get Payhead by Addition**/
	getpayhead(){
		$("#showLoader").show();
		GetData('payroll/getpayheadbyadd').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					payhead : responseJson
				});
			}
		});
	}
	
	/** get Payhead by Deduction**/
	getphead(){
		
		GetData('payroll/getpayheadbyded').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					phead : responseJson
				});
			}
		});
	}
	
	/** Get Academic Year **/
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear : academic
				});
				$('#year option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	
	/** get Employee By Department **/
	getemployee(){	
		var dt = $("#dept").val();
		$("#showLoader").show();
		GetData('employee/getempbydept/'+dt).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.state.emptotal = [];
				this.setState({
					emp : responseJson
				});
				this.state.emptotal = new Array(this.state.emp.length);
			
			}
		});
	}
	
	/** get Department **/
	getdepartment(){
		
		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					depat : responseJson
				});
			}
		});
	}
	
	/** get Salary Advance **/
	getsaladvance(){
		
		GetData('payroll/getloans').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					advancedata : responseJson
				});
			}
		});
	}
	
	/** get Deduct Salary Advance **/
	getdeductloan(){
		
		GetData('payroll/getdeduction').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					deductdata : responseJson
				});
			}
		});
	}
	
	getsalsetdata(){
		
		GetData('payroll/getsalsetting').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	getempsaladd(empid,index){
		
		var dat = [];
		var addtot = 0.00;
		
		for(var i=0;i<this.state.payhead.length;i++){
			
			if(this.getamtbyempid(empid,this.state.payhead[i].id)){
				dat.push(<td>{this.getamtbyempid(empid,this.state.payhead[i].id)}</td>);
				addtot += parseFloat(this.getamtbyempid(empid,this.state.payhead[i].id));
				this.state.emptotal[index] = addtot;
			}
			else{
				
				dat.push(<td></td>);
			}
		}
		return dat;
	}
	
	getempsaldeduct(empid,index){
		
		var dat1 = [];
		var dedtot = 0.00;
		
		for(var i=0;i<this.state.phead.length;i++){
			
			if(this.getamtbyempid(empid,this.state.phead[i].id)){
				
				dat1.push(<td>{this.getamtbyempid(empid,this.state.phead[i].id)}</td>);
				this.state.emptotal[index] -= parseFloat(this.getamtbyempid(empid,this.state.phead[i].id));
				
			}
			else if(this.getsaladvancebyempid(empid,this.state.phead[i].id)){
					
				dat1.push(<td>{this.getsaladvancebyempid(empid,this.state.phead[i].id)}</td>);
				this.state.emptotal[index] -= parseFloat(this.getsaladvancebyempid(empid,this.state.phead[i].id));
				
			}
			else{
				
				dat1.push(<td></td>);
			}
		}
		
		return dat1;
	}
	
	getsalaryadvance(empid,index){
		
		var dat3 = [];
		
		if(this.checkdeddvance(empid)!=false){
			
			dat3.push(<td>{this.checkdeddvance(empid)}</td>);
			this.state.emptotal[index] -= this.checkdeddvance(empid);
		}
		else{
			
			
			dat3.push(<td>{this.checksaladvance(empid)}</td>);
			this.state.emptotal[index] -= this.checksaladvance(empid);
		}
		
		return dat3;
	}
	
	checksaladvance(empid){
		
		var boolstate = false;
		var ac = $("#year").val();
		var month = $("#month").val();
		for(var k=0; k<this.state.advancedata.length;k++){
			
			if(this.state.advancedata[k].acyear == ac && this.state.advancedata[k].month == month && this.state.advancedata[k].employee == empid){
				
				boolstate = (this.state.advancedata[k].amount)-(this.state.advancedata[k].paidamount);
				break;
			}
			else{
				
				boolstate = false;
			}
		}
		return boolstate;
	}
	
	checkdeddvance(empid){
		
		var boolstate = false;
		var ac = $("#year").val();
		var year = this.state.year;
		var month = $("#month").val();
		
		for(var k=0; k<this.state.deductdata.length;k++){
			
			if(this.state.deductdata[k].acyear == ac && this.state.deductdata[k].year == year && this.state.deductdata[k].month == month && this.state.deductdata[k].employee == empid){
				
				boolstate = this.state.deductdata[k].amount;
				break;
			}
			else{
				
				boolstate = false;
			}
		}
		return boolstate;
	}
	
	getleaveded(empid,index){
		
		var dat2 = [];
		
		if(this.checkleaveded(empid)!=false){
			
			var less = Math.round((this.checkleaveded(empid))*((this.getamtbyempid(empid,1))/30));
			dat2.push(<td>{less}</td>);
			this.state.emptotal[index] -= less;
		}
		else{
			
			var less = Math.round((this.checkabsentded(empid))*((this.getamtbyempid(empid,1))/30));
			dat2.push(<td>{less}</td>);
			this.state.emptotal[index] -= less;
		}
		
		return dat2;
	}
	
	checkabsentded(empid){
		
		var boolstate = 0;

		for(var k=0; k<this.state.absent.length;k++){
			
			if(this.state.absent[k].employee == empid){
				
				boolstate++;
			}
		}
		return boolstate;
	}
	
	checkleaveded(empid){
		
		var boolstate = false;
		var ac = $("#year").val();
		var year = this.state.year;
		var month = $("#month").val();
		for(var k=0; k<this.state.posts.length;k++){
			
			if(this.state.posts[k].acyear == ac && this.state.posts[k].year == year && this.state.posts[k].month == month && this.state.posts[k].employee == empid){
				
				boolstate = this.state.posts[k].noofdeductdays;
				break;
			}
			else{
				
				boolstate = false;
			}
		}
		return boolstate;
	}
	
	getamtbyempid(empid,payid){
		
		var year = $("#year").val();
		var bstate = false;
		 for(var j=0; j<this.state.data.length;j++){
			 
			if(this.state.data[j].acyear == year && this.state.data[j].employee == empid && this.state.data[j].payhead == payid){
				
				bstate = this.state.data[j].amount;
				break;
			}
			else{
				
				bstate = false;
			}
		 }
		return bstate;
	}
	
	getsaladvancebyempid(empid,payid){
		
		var bstate = false;
		var mon = $("#month").val();
		var year = $("#year").val();
		 for(var j=0; j<this.state.advancedata.length;j++){
			 
			if(this.state.advancedata[j].acyear == year && this.state.advancedata[j].employee == empid && this.state.advancedata[j].payhead == payid && this.state.advancedata[j].month == mon){
				
				bstate = this.state.advancedata[j].amount;
				break;
			}
			else{
				
				bstate = false;
			}
		 }
		return bstate;
	}
	
	daysInMonth() {
		
		var month = $("#month").val();
		var year = this.state.year;
		var ndays = new Date(year, month, 0).getDate();
		// console.log(ndays+1);
		return ndays; 
	}
	
	getsunday(){
		
		var month = $("#month").val();
		var year = this.state.year;
		
		GetData('payroll/getsundaycount/'+year+'/'+month).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					count : responseJson
				});
			}
		});
		
	}
	
	getleave(){
		
		var month = $("#month").val();
		var year = this.state.year;
		
		GetData('payroll/getholidays/'+year+'/'+month).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					leave : responseJson
				});
			}
		});
	}
	
  render() {
	
	if(this.state.acyear!='' && this.state.month!='' && this.state.depart!=''){
		
		$("#suballtable").show();
		$("#subalbody").show();
	}
	else{
		
		$("#suballtable").hide();
		$("#subalbody").hide();
	}
	
	var acyear = this.state.accyear;
	var dept = this.state.depat;
	
	 // var year = (new Date()).getFullYear();
	
	/** set month in select box **/
	this.month = [
		{value : '', name: 'Select Month'},
		{value : '01', name: 'January'},
		{value : '02', name: 'February'},
		{value : '03', name: 'March'},
		{value : '04', name: 'April'},
		{value : '05', name: 'May'},
		{value : '06', name: 'June'},
		{value : '07', name: 'July'},
		{value : '08', name: 'August'},
		{value : '09', name: 'September'},
		{value : '10', name: 'October'},
		{value : '11', name: 'November'},
		{value : '12', name: 'December'}
	];
		
	return (
		<div className="animated fadeIn">
		  <div className={this.state.alertClass}>
			{this.state._message}
		  </div>
			<Row>
			  <Col md="12">
				<Card>
				  <form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Salary Abstract</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						Academic Year : &nbsp;&nbsp;
						<select name="acyear" onChange={this.onChange} required id="year">
							<option value="">Select Academic Year</option>
							{
								acyear.map(function (item) {
									return <option value={item.id }>{item.value}</option>;
								})
							}
						</select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						Month : &nbsp;&nbsp;
						<select name="month" onChange={this.onChange} id="month" required>
							{this.month.map((e, key) => {
								return <option key={key} value={e.value}>{e.name}</option>;
							})}		
						</select>&nbsp;&nbsp;
						Department : &nbsp;&nbsp;
						<select name="depart" onChange={this.onChange} required id="dept" >
							<option value="">Select Department</option>
							<option value="all">All</option>
							{
								dept.map(function (item) {
									return <option value={item.id }>{item.department}</option>;
								})
							}
						</select>&nbsp;&nbsp;
						No of Working Days : {(this.daysInMonth())-(this.state.count)-(this.state.leave)}
					</CardHeader>
					<CardBody id="subalbody">
						<Row>
						  <Col md="12">
							<Table responsive bordered  id="suballtable">
							  <thead>
								<tr>
									<th>#</th>
									<th colSpan={this.state.payhead.length}>Addition</th>
									<th colSpan={this.state.phead.length}>Deduction</th>
									<th rowSpan="2">Salary Advance/Loans</th>
									<th rowSpan="2">Loss of Pay</th>
									<th rowSpan="2">Total</th>
								</tr>
								<tr>
									<th>Employee Name</th>
									{this.state.payhead.map(item =>
									
										<th>{item.payheadname}</th>
									)}
									{this.state.phead.map(item =>
									
										<th>{item.payheadname}</th>
									)}
									
								</tr>
							  </thead>
							  <tbody>
								{this.state.emp.map((item,index) =>
						 
									<tr key = {index}>
										<td id="subtext">{item.empname}</td>
										{this.getempsaladd(item.id,index)}
										{this.getempsaldeduct(item.id,index)}
										{this.getsalaryadvance(item.id,index)}
										{this.getleaveded(item.id,index)}
										<td>{this.state.emptotal[index]}</td>
									</tr>
								)}
							  </tbody>
							</Table>
						  </Col>
						</Row>
					</CardBody>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default EmployeeSalary;


// WEBPACK FOOTER //
// ./src/payroll/EmployeeSalary/EmployeeSalary.js